<template>
  <div class="page">
    <img class="bg-pic" src="@/assets/new/company.png" alt="" />
    <div class="content-center">
      <div class="news-item">
        <div class="date">
          <div class="yearMonth">2024-03</div>
          <div class="day">21</div>
        </div>
        <div class="item-content">
          <div class="title">
            <span>探讨行业发展 | 支付要闻更新</span>
          </div>
          <div class="little-title">
            <span>2024年也将是支付行业至关重要的一年</span>
          </div>
          <div class="content">
            <span>
              随着《非银行支付机构监督管理条例》（以下简称《条例》）的正式发布不仅政策落地，同时行业也面临着各类转型机遇。
              在此，聚合云集团提炼要点要闻，针对内容进行分享，希望能够给行业人带来启发。
            </span>
          </div>
        </div>
        <div class="but">
          <el-button type="primary" @click="goDetail(1)">查看详情</el-button>
        </div>
      </div>
      <div class="news-item">
        <div class="date">
          <div class="yearMonth">2023-12</div>
          <div class="day">21</div>
        </div>
        <div class="item-content">
          <div class="title">
            <span>支付监管规则更新强化《非银行支付机构监督管理条例》发布</span>
          </div>
          <div class="little-title">
            <span>非银行支付业务</span>
          </div>
          <div class="content">
            <span>
              随着我国数字经济、电子商务等新业态的兴起而快速发展，在小额、便民支付领域发挥了重要作用。数据显示，当前支付机构
              年交易量超1万亿笔、金额近400万亿元，分别占全国电子支付业务总量的约八成和一成，日均备付金余额超2万亿元...
            </span>
          </div>
        </div>
        <div class="but">
          <el-button type="primary" @click="goDetail(2)">查看详情</el-button>
        </div>
      </div>
      <div class="news-item">
        <div class="date">
          <div class="yearMonth">2023-10</div>
          <div class="day">18</div>
        </div>
        <div class="item-content">
          <div class="title">
            <span>中秋国庆支付数据发布：部分行业增长明显</span>
          </div>
          <div class="little-title">
            <span>支付宝：境外钱包在境内单日交易笔数最高增幅200%</span>
          </div>
          <div class="content">
            <span>
              支付宝今年发布的数据主要围绕亚运会展开，非常亮眼的是其跨境相关数据。支付宝数据显示，杭州公交地铁单日支付宝刷码乘
              车量突破历史峰值。亚运六城的旅游热度“水涨船高”，仅景区的单日消费较去年最高涨幅达270%。
            </span>
          </div>
        </div>
        <div class="but">
          <el-button type="primary" @click="goDetail(3)">查看详情</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsList",
  data() {
    return {};
  },
  mounted(){
    this.backTop()
  },
  methods: {
    goDetail(i) {
      this.$router.push({ name: "NewsDetail" });
      localStorage.setItem("id", i);
    },
    backTop() {
      let that = this;
      cancelAnimationFrame(that.timer);
      that.timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          that.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(that.timer);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.page {
  padding-top: 65px;
  .bg-pic {
    width: 100%;
    display: block;
  }
}

/* ========== PC 端样式（完全保持你原来的） ========== */
.content-center {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  .news-item {
    height: 200px;
    display: flex;
    position: relative;
    border-bottom: 1px solid #e7eaf1;
    padding-top: 25px;
    align-items: flex-start;
  }
  .date {
    width: 150px;
    height: 150px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #868e9c;
    border: 1px solid #868e9c;
    flex-shrink: 0;
    .yearMonth {
      font-size: 16px;
    }
    .day {
      font-weight: 600;
      font-size: 48px;
      color: #868e9c;
    }
  }
  .item-content {
    padding-left: 30px;
    width: calc(100% - 300px);
    .title {
      font-size: 28px;
      color: #333;
    }
    .little-title {
      font-size: 20px;
      color: #868e9c;
      padding-top: 5px;
    }
    .content {
      padding-top: 10px;
      font-size: 20px;
      color: #707172;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .but {
    width: 150px;
    position: absolute;
    right: 0;
    top: 70px;
    font-size: 20px;
    text-align: center;
    .el-button {
      width: 120px;
      height: 50px;
      background-color: #de1f26;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 2px;
    }
  }
}

/* ========== 移动端适配（自动生效） ========== */
@media screen and (max-width: 768px) {
  .content-center {
    padding: 20px 15px;
  }
  .news-item {
    height: auto !important;
    flex-direction: column !important;
    padding-bottom: 20px;
    position: relative;
  }
  .date {
    width: 100px !important;
    height: 100px !important;
    margin-bottom: 15px;
    .yearMonth {
      font-size: 14px !important;
    }
    .day {
      font-size: 32px !important;
    }
  }
  .item-content {
    width: 100% !important;
    padding-left: 0 !important;
  }
  .title {
    font-size: 20px !important;
  }
  .little-title {
    font-size: 16px !important;
  }
  .content {
    font-size: 15px !important;
  }
  .but {
    position: static !important;
    width: 100% !important;
    text-align: left !important;
    margin-top: 15px;
    .el-button {
      width: 110px !important;
      height: 42px !important;
      font-size: 14px !important;
    }
  }
}
</style>
